import React from 'react';
import Button from '../Button';

import newsletterBG from '../../assets/img/newsletter/shape-1-1.png';

const Newsletter = () => {
  return (
    <div
      className="it-newsletter-area p-relative z-index theme-bg pt-100 pb-105"
      style={{ backgroundImage: `url(${newsletterBG})` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-8">
            <div className="it-newsletter-wrap text-center">
              <h4 className="it-section-title text-white pb-40">
                Get Connected With Affirm And Enjoy Your New Experience
              </h4>
              <div className="it-newsletter-input-wrap d-flex align-items-center">
                <input type="email" placeholder="Your email address" />
                <button type="submit" className="it-btn-theme white-bg">
                  <Button btnText="Subscribe" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
